<template>    
  <v-layout column>
    <v-layout wrap px-3 align-center justify-center class="inset" v-if="assets">
        <v-flex v-if="" class="animated">
          <v-widget title="Assets beheren">
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4>
                <v-layout justify-center grey lighten-4>
                    <v-flex  xs10 md8 lg6 mt-4> 
                        <v-text-field
                            label="Solo"
                            placeholder="Voer een zoekterm in"
                            solo
                            type="text"
                            append-outer-icon="search"
                            @click:append-outer="doSearch"
                            @keyup.native="doSearch"
                            
                            v-model="searchTerm"
                            :loading="isLoading"
                        ></v-text-field>
                    </v-flex>
                    
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-2>
                <v-data-table :headers="grids.assetHeaders" :items="assets" :pagination.sync="pagination"  hide-actions>
                  <template slot="items" slot-scope="props">
                    <tr @click="selectAsset(props.item)">
                      <td class="text-xs-left">{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.unitIdentifier}}</td>
                      <td class="text-xs-left">{{ props.item.group.name}}</td>
                      <td class="text-xs-left">{{ props.item.street}} {{ props.item.city}}</td>                      
                      <td class="text-xs-left" v-if="props.item.lastSeen">{{ props.item.lastSeen |timeAgoShort }}</td>
                      <td class="text-xs-left" v-else><i>Nooit</i></td>
                      <td style="width:50px;" >
                        <i class="far fa-battery-full green--text" style="font-size:16px;" v-if="props.item.batteryStatus == 'FULL'"></i>
                        <i class="far fa-battery-three-quarters green--text" style="font-size:16px;" v-if="props.item.batteryStatus == 'VERY_GOOD'"></i>
                        <i class="far fa-battery-half green--text" style="font-size:16px;" v-if="props.item.batteryStatus == 'OK'"></i>
                        <i class="far fa-battery-quarter orange--text" style="font-size:16px;" v-if="props.item.batteryStatus == 'LOW'"></i>
                        <i class="far fa-battery-empty red--text" style="font-size:16px;" v-if="props.item.batteryStatus == 'EMPTY'"></i>
                      </td>
                      
                      <td class="status-badge" :style="`width:160px; background-color: ${props.item.statusColor}`">{{ (props.item.statusType == 'NONE') ? 'Ok' : props.item.statusType }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-if="assetsMeta && assetsMeta.pagination && assetsMeta.pagination.total_pages > 1" d-flex pt-2>
                    <v-pagination              
                        v-model="page"
                        :length="assetsMeta.pagination.total_pages"                           
                        @input="loadData()">
                    </v-pagination>
                </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import * as types from "../../store/types"
import { mapGetters } from "vuex"
import TopInfoPanel from '../../components/global/TopInfoPanel'
import VWidget from '../../components/global/VWidget'
import EditAsset from '../../components/asset/EditAsset'
import _ from 'lodash'

export default {
    components: {
        TopInfoPanel,
        VWidget,
        EditAsset
    },
    data(){
        return {
            grids: {
                assetHeaders: [
                { text: "Naam", sortable: true, value: 'name' },
                { text: "Identifier", sortable: true, value: 'unit_identifier' },
                { text: "Groep", sortable: true, value: 'group.name' },
                { text: "Locatie", sortable: false },
                { text: "Laatst gezien", sortable: true, value: 'last_seen' },
                { text: "", sortable: true, value: 'battery_status' },
                { text: "Status", sortable: true, value: 'status_type' }
                ]
            },
            selectedAsset: null,
            page: 1,
            searchTerm: '',
            isLoading: false,
            latestResults: 0,
            resultAmount: 30, // Determine how many results we show in the table. 
            pagination: {},
            sortField: null,
            sortOrder: null
        }

    },
    computed: {
        ...mapGetters({
            assets: types.ASSETS_SEARCH,        
            assetsMeta: types.ASSETS_SEARCH_META
        }),
    },
    methods:{
        loadData(sortField = null, sortOrder = 'ASC'){
            let sort = {sort_by: sortField, sort_order: sortOrder}
           
            if(this.sortField != null && this.sortOrder != null) // Sort based on stored sortField en format. This is used to keep track of the sortCriteria for opening/closing edit popup.
               sort = {sort_by: this.sortField, sort_type: this.sortOrder}
            else if(sortField == null) // No sort given, so we remove the sort from the search query.
                sort = {};    

            this.$store.dispatch(types.ASSETS_SEARCH, {data:{searchTerm: this.searchTerm}, params:{include: "type,group", per_page: this.resultAmount, page:this.page, ...sort}}).then(() => {
                    if(this.latestResults != this.assetsMeta.pagination.total_pages){
                        this.page = 1
                    }
                    this.latestResults = this.assetsMeta.pagination.total_pages
                    this.isLoading = false                        
                })
        },
        doSearch(){
            this.loadData()
            // console.log("Searching!")
            // this.isLoading = 'info'
            // if(this.searchTerm.length > 0){
            //     this.$store.dispatch(types.ASSETS_SEARCH, {data: {searchTerm: this.searchTerm}, params: {include: 'group', per_page: 50, page:this.page,sort_by: 'name'}}).then(() => {
            //         this.isLoading = false                        
            //     })
            // }
        },
        selectAsset(a){
            this.selectedAsset = a
            this.dialog = true

            this.$emit("assetSelected", a);
        },
    },
    
    mounted(){
        this.loadData('name');
    },
    watch: {
      pagination: {
        handler () {
           this.pagination.rowsPerPage = this.resultAmount;

           this.sortField = this.pagination.sortBy;
       
           if(this.pagination.descending == true)
              this.sortOrder = 'DESC'
           else if(this.pagination.descending == false)
              this.sortOrder = 'ASC'
           else if(this.pagination.descending == null){ // No sort provided
              this.sortOrder = null;
              this.sortField = null;
           }

           this.loadData(this.sortField, this.sortOrder);
          
        },
        deep: true
      }
    },
}
</script>